/*
 * quantity-breaks-engine.js — rachev
 * Drives every .qb-wrapper[data-product-id] tiered radio-card selector.
 *
 * On card click it:
 *   1. moves .qb-active / .qbr-active to the clicked card,
 *   2. writes the chosen qty into the target form's hidden quantity input,
 *   3. RECOMPUTES the discounted price from the live variant (never trusts a
 *      stored data-final-price),
 *   4. pushes the qty onto every sticky [data-cart-add] button's dataset.qty,
 *   5. fires CustomEvent('qb:state-changed', { quantity, qbDiscount, basePrice,
 *      baseComparePrice, bubbles:true }) — the single contract consumed by
 *      price-manager.js and sticky-atc-bridge.js.
 *
 * qb:state-changed contract (MUST match price-manager.js + sticky-atc-bridge.js):
 *   detail.quantity         {number}  chosen units
 *   detail.qbDiscount       {number}  tier discount percent (0/10/15/20…)
 *   detail.basePrice        {number}  discounted total in cents (recomputed)
 *   detail.baseComparePrice {number}  total compare-at in cents
 */
(function () {
  'use strict';

  if (window.__qbEngineInit) return;
  window.__qbEngineInit = true;

  function initWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.qbBound === 'true') return;
    wrapper.dataset.qbBound = 'true';

    var uid = wrapper.dataset.qbUid;
    var formId = wrapper.dataset.formId;

    var variants = [];
    var json = uid ? document.getElementById('qb-variants-' + uid) : null;
    if (json) {
      try { variants = JSON.parse(json.textContent) || []; } catch (e) { variants = []; }
    }

    var firstVariant = variants[0] || null;

    function getForm() {
      var form = formId ? document.getElementById(formId) : null;
      if (!form) {
        form =
          document.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('[id*="product-form"] form') ||
          document.querySelector('[id*="product-form"]');
      }
      return form;
    }

    function discountForOption(optionNum) {
      var key = 'qb' + optionNum + 'Discount';
      var d = parseFloat(wrapper.dataset[key]);
      return isNaN(d) ? 0 : d;
    }

    // RECOMPUTE base price from the live variant — never read data-final-price.
    function computePrices(qty, optionNum) {
      var unit = firstVariant ? firstVariant.price : 0;
      var unitCompare =
        firstVariant && firstVariant.compare_at_price
          ? firstVariant.compare_at_price
          : unit;

      var total = unit * qty;
      var totalCompare = unitCompare * qty;
      var discount = discountForOption(optionNum);
      var discounted = Math.round(total - (total * discount) / 100);

      return {
        quantity: qty,
        qbDiscount: discount,
        basePrice: discounted,
        baseComparePrice: totalCompare
      };
    }

    function setFormQuantity(qty) {
      var form = getForm();
      var inputs = form
        ? form.querySelectorAll('input[name="quantity"]')
        : document.querySelectorAll('input[name="quantity"]');

      if (!inputs || inputs.length === 0) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.value = qty;
        (form || document.body).appendChild(input);
        return;
      }
      inputs.forEach(function (el) {
        el.value = qty;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function pushQtyToSticky(qty) {
      document
        .querySelectorAll('.sticky-atc [data-cart-add], .sticky-atc button[data-cart-add]')
        .forEach(function (btn) {
          btn.dataset.qty = qty;
        });
    }

    function fireStateChanged(detail) {
      document.dispatchEvent(
        new CustomEvent('qb:state-changed', {
          detail: {
            quantity: detail.quantity,
            qbDiscount: detail.qbDiscount,
            basePrice: detail.basePrice,
            baseComparePrice: detail.baseComparePrice
          },
          bubbles: true
        })
      );
    }

    function selectOption(option) {
      if (!option || option.classList.contains('qb-sold-out')) return;

      var qty = parseInt(option.dataset.qty, 10) || 1;
      var optionNum = parseInt(option.dataset.option, 10) || 1;

      wrapper.querySelectorAll('.qb-option').forEach(function (o) {
        o.classList.remove('qb-active', 'qbr-active');
      });
      option.classList.add('qb-active', 'qbr-active');
      // force reflow so active styles apply before paint
      void option.offsetHeight;

      setFormQuantity(qty);
      pushQtyToSticky(qty);

      // v3: тир с избрани продукти носи готова цена (сума от реалните продукти,
      // сметната в Liquid) → ползвай нея. Иначе legacy recompute от варианта.
      var prices;
      var fp = parseInt(option.dataset.finalPrice, 10);
      if (!isNaN(fp) && fp > 0) {
        var cp = parseInt(option.dataset.comparePrice, 10);
        prices = {
          quantity: qty,
          qbDiscount: discountForOption(optionNum),
          basePrice: fp,
          baseComparePrice: (!isNaN(cp) && cp > 0) ? cp : fp
        };
      } else {
        prices = computePrices(qty, optionNum);
      }

      // Reflect recomputed prices back into the card (keeps DOM truthful).
      var priceEl = option.querySelector('.qb-price, .qbr-price');
      var compareEl = option.querySelector('.qb-compare, .qbr-compare');
      if (priceEl) priceEl.textContent = formatMoney(prices.basePrice);
      if (compareEl) {
        if (prices.baseComparePrice > prices.basePrice) {
          compareEl.textContent = formatMoney(prices.baseComparePrice);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      fireStateChanged(prices);
    }

    // Currency-aware. The theme does NOT define Shopify.formatMoney, so a
    // naive fallback drops the currency sign. EUR keeps the "12,99 €" look
    // (matches the Liquid render); other presentment currencies (HUF…) go
    // through Intl with the wrapper's currency+locale.
    function formatMoney(cents) {
      var cur = wrapper.dataset.currency || 'EUR';
      var loc = wrapper.dataset.locale || 'bg';
      if (cur === 'EUR') {
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }
      if (cur === 'CZK') {
        // Canon: "364 Kc" style — whole crowns, space thousands, no decimals, suffix.
        return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' K\u010d';
      }
      if (cur === 'RSD') {
        // Canon RS: "1 799 RSD" — whole dinars, space thousands, no decimals, suffix.
        return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' RSD';
      }
      if (cur === 'RON') {
        // Canon RO: "77 lei" — whole lei, dot thousands, NBSP, suffix, no bani.
        return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '\u00a0lei';
      }
      if (cur === 'PLN') {
        // Canon PL: "72 zł" — whole zloty, NBSP, suffix, no groszy.
        return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + '\u00a0zł';
      }
      if (cur === 'HUF') {
        // Canon: "14 500 Ft" — whole forints, space thousands, no decimals.
        return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft';
      }
      try {
        return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + cur;
      }
    }
    window.__rachevFormatMoney = formatMoney;

    function checkSoldOutOptions() {
      wrapper.querySelectorAll('.qb-option').forEach(function (option) {
        // A tier is sold out only if the underlying variant is unavailable.
        var anyAvailable = variants.some(function (v) { return v.available; });
        if (variants.length && !anyAvailable) {
          if (option.querySelector('.qb-sold-out-badge')) return;
          option.classList.add('qb-sold-out');
          option.style.pointerEvents = 'none';
          var badge = document.createElement('div');
          badge.className = 'qb-sold-out-badge';
          badge.textContent = 'SOLD OUT';
          option.appendChild(badge);

          if (option.classList.contains('qb-active')) {
            option.classList.remove('qb-active', 'qbr-active');
          }
        }
      });
    }

    function bindClicks() {
      wrapper.querySelectorAll('.qb-option').forEach(function (option) {
        option.addEventListener('click', function () {
          selectOption(this);
        });
      });
    }

    function init() {
      bindClicks();
      checkSoldOutOptions();

      var active = wrapper.querySelector('.qb-option.qb-active:not(.qb-sold-out)');
      if (!active) active = wrapper.querySelector('.qb-option:not(.qb-sold-out)');
      if (active) selectOption(active);
    }

    init();
  }

  function boot() {
    document.querySelectorAll('.qb-wrapper[data-product-id]').forEach(initWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Theme Editor block load.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  }
})();
